module.exports = __webpack_public_path__ + "img/bruce.dbb8def1.jpg";